<template>
  <v-container fluid class="login-background fill-height">
    <v-row justify="center">
      <v-col cols="12" sm="8" md="3">
        <v-form ref="form" v-model="valid" :lazy-validation="lazy">
          <v-card class="login-card pa-6 rounded-xl" elevation="16" dark>
            <v-card-title class="headline layout justify-center mb-3"
              >Portal del Jugador</v-card-title
            >
            <v-card-subtitle class="layout justify-center"
              >Inicio de Sesión</v-card-subtitle
            >
            <v-container class="pt-0">
              <v-row dense>
                <v-col cols="12">
                  <v-text-field
                    v-model="usuario"
                    prepend-icon="mdi-account"
                    :rules="nameRules"
                    label="Documento"
                    required
                    @keypress="onlyNumber"
                    @keypress.enter="signin"
                  ></v-text-field>

                  <v-text-field
                    v-model="pass"
                    prepend-icon="mdi-lock"
                    :rules="passRules"
                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    label="Contraseña"
                    :type="showPassword ? 'text' : 'Password'"
                    required
                    @keypress.enter="signin"
                    @click:append="showPassword = !showPassword"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
            <div class="pull-right">
              <v-card-title class="headline layout justify-center pa-0">
                <v-btn
                  color="success"
                  class="mr-4"
                  :disabled="!valid || loading"
                  :loading="loading"
                  @click="signin"
                  >Acceder</v-btn
                >
              </v-card-title>
              <v-card-title
                class="headline layout justify-center pb-1 mb-1 mt-3"
              >
                <v-btn
                  @click="recuperarPass"
                  x-small
                  class="ma-2"
                  tile
                  outlined
                  color="white"
                >
                  <v-icon left>mdi-lock</v-icon>¿Olvidaste tu contraseña?
                </v-btn>
              </v-card-title>
            </div>

            <RecuperoPass
              v-if="showRecuperoPass"
              :visible="showRecuperoPass"
              @close="showRecuperoPass = false"
            ></RecuperoPass>
          </v-card>
        </v-form>
        <v-card class="login-card pa-6 rounded-xl mt-3" elevation="16" dark>
          <v-card-title class="d-flex registration-card">
            <h5>¿No tienes una cuenta?</h5>
            <v-btn color="warning" small class="ml-3" @click="registrarse()"
              >Registrate</v-btn
            >
          </v-card-title>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import axios from "@/axios-auth";
import router from "@/router";
import RecuperoPass from "../components/RecuperoPass.vue";
import { showAlert } from "@/utils/toast";

export default {
  name: "Login",
  props: {
    urlInstitucion: {
      required: false,
      default: "",
    },
  },
  data: () => ({
    valid: false,
    lazy: false,
    showPassword: false,
    loading: false,
    showRecuperoPass: false,
    usuario: "",
    nameRules: [(v) => !!v || "El documento es un dato requerido"],
    pass: "",
    passRules: [(v) => !!v || "La contraseña es un dato requerido"],
    nombreInstitucion: "",
    idInstitucion: 0,
    showCronogramas: false,
  }),
  methods: {
    verEstudios() {
      router.push("/Estudios");
    },
    verProfesionales() {
      this.showCronogramas = true;
    },
    isMobile() {
      if (window.innerWidth < 400) {
        return true;
      } else {
        return false;
      }
    },
    scrollToTop() {},
    recuperarPass() {
      this.showRecuperoPass = true;
    },
    signin() {
      if (this.valid) {
        const formData = {
          usuario: this.usuario,
          pass: this.pass,
        };
        this.loading = true;

        let self = this;
        axios
          .get("/Institucional/Login?", {
            params: {
              usuario: formData.usuario,
              pass: formData.pass,
            },
          })
          .then(function (response) {
            if (response.data == "Usuario Inexistente") {
              self.loading = false;
              self.showAlert({
                icon: "warning",
                title: "Documento o Contraseña inválidos.",
                vm: self,
                timer: 2000,
              });
            } else {
              if (response.data == "Usuario Inactivo") {
                self.loading = false;
                self.showAlert({
                  icon: "warning",
                  title: "Cuenta Inactiva.",
                  vm: self,
                  timer: 2000,
                });
              } else {
                self.$store.commit("saveUserData", {
                  token: response.data.token,
                  idUsuarioPaciente: response.data.idUsuarioPaciente,
                  nombreUsuarioPaciente: response.data.nombreUsuarioPaciente,
                });

                localStorage.setItem("token", response.data.token);
                localStorage.setItem(
                  "idUsuarioPaciente",
                  response.data.idUsuarioPaciente,
                );
                self.loading = false;
                self.showAlert({
                  icon: "success",
                  title: "Ingreso Exitoso.",
                  vm: self,
                  timer: 2000,
                });
                router.push({ path: "/Home" });
              }
            }
          })
          .catch(function (error) {
            this.loading = false;
          });
      }
    },
    showAlert(alertInfo) {
      showAlert(alertInfo);
    },
    onlyNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if (keyCode < 48 || keyCode > 57) {
        // 46 is dot
        $event.preventDefault();
      }
    },
    registrarse() {
      router.push("/Register");
    },
  },
  async created() {
    this.$store.commit("clearAuthData");
    let self = this;

    if (this.urlInstitucion) {
      this.$store.commit("setUrlInstitucion", this.urlInstitucion);
      axios
        .get("/Login/GetDatosInstitucion", {
          params: {
            urlInstitucion: this.urlInstitucion,
          },
        })
        .then((response) => {
          this.$store.commit("setIdInstitucion", response.data.idInstitucion);
          this.$store.commit(
            "setNombreInstitucion",
            response.data.nombreInstitucion,
          );
          this.$store.commit("setUrlInstitucion", response.data.urlInstitucion);
          this.$store.commit("setEsEmpresa", response.data.esEmpresa);
          this.nombreInstitucion = response.data.nombreInstitucion;
          this.idInstitucion = response.data.idInstitucion;
        })
        .catch(() => {
          self.showAlert({
            icon: "warning",
            title: "El complejo no existe!",
            vm: self,
            timer: 3000,
          });
          router.push("/Login");
        });
    } else {
      this.$store.commit("resetDatosInstitucion");
    }
  },
  components: {
    RecuperoPass,
  },
};
</script>
<style scoped>
.headline {
  font-size: 1.4rem !important;
}
.login-background {
  height: calc(100vh - 64px);
  position: relative;
  overflow: hidden;
  background: linear-gradient(135deg, #1976d2, #203a43, #2c5364);
}

/* Blob 1 */
.login-background::before {
  content: "";
  position: absolute;
  width: 420px;
  height: 420px;
  background: radial-gradient(circle at center, #00ff9c, transparent 70%);
  top: -120px;
  left: -120px;
  opacity: 0.45;
}

/* Blob 2 */
.login-background::after {
  content: "";
  position: absolute;
  width: 520px;
  height: 520px;
  background: radial-gradient(circle at center, #00c6ff, transparent 70%);
  bottom: -180px;
  right: -180px;
  opacity: 0.35;
}
.login-card {
  backdrop-filter: blur(10px);
  background: rgba(20, 35, 45, 0.85);
  border: 1px solid rgba(255, 255, 255, 0.08);
}
@keyframes float {
  0% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-20px);
  }
  100% {
    transform: translateY(0);
  }
}

.login-background::before,
.login-background::after {
  animation: float 12s ease-in-out infinite;
}

.registration-card {
  flex-direction: column;
  justify-content: space-around;
  gap: 1rem;
}
</style>
